import React , {useState} from "react";
import { Button, ButtonGroup, Card, Col, Container, ListGroup, Row, ToggleButton } from "react-bootstrap";
import Pic from "../../../assets/images/icons/user.png";
import { useNavigate } from "react-router-dom";


function NotificationFrontPage(){

  const [checked, setChecked] = useState(false);
  const navigate = useNavigate();


    return(
        <>

        <section className="white_bg py-4">
            <Container className="user_container">
                <Button
                className="px-3"
                variant="page_back"
                onClick={() => navigate(-1)}
                >
                    <svg
                        className="me-3"
                        width="13"
                        height="24"
                        viewBox="0 0 13 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                        d="M12.3965 1.49949C12.3961 1.89718 12.2379 2.27846 11.9565 2.55949L4.28448 10.2315C4.05227 10.4636 3.86806 10.7393 3.74238 11.0426C3.6167 11.346 3.55202 11.6711 3.55202 11.9995C3.55202 12.3279 3.6167 12.653 3.74238 12.9564C3.86806 13.2597 4.05227 13.5353 4.28448 13.7675L11.9465 21.4345C12.2197 21.7174 12.3709 22.0963 12.3675 22.4896C12.3641 22.8829 12.2063 23.2591 11.9282 23.5372C11.6501 23.8153 11.2739 23.9731 10.8806 23.9765C10.4873 23.9799 10.1084 23.8287 9.82548 23.5555L2.16348 15.8945C1.13325 14.8622 0.554641 13.4634 0.554641 12.005C0.554641 10.5466 1.13325 9.14776 2.16348 8.11549L9.83548 0.443495C10.045 0.233877 10.3118 0.0910072 10.6024 0.0329132C10.893 -0.0251808 11.1943 0.00410271 11.4683 0.117071C11.7423 0.23004 11.9766 0.421629 12.1418 0.667664C12.307 0.913698 12.3956 1.20315 12.3965 1.49949Z"
                        fill="#14183E"
                        />
                    </svg>
                    Back
                </Button>
                <Row className="justify-content-center">
                    <Col md="9">
                        <Card className="p-3" style={{background: '#F9F9F9'}}>

                            <div className="notifications_list">

                                <div className="d-flex justify-content-end mb-3">
                                    <ToggleButton className="mark_as_read_btn" size="sm"
                                    id="toggle-check"
                                    type="checkbox"
                                    variant="secondary"
                                    checked={checked}
                                    value="1"
                                    onChange={(e) => setChecked(e.currentTarget.checked)}
                                    >Mark All As Read</ToggleButton>
                                </div>
                                <ListGroup className="">
                                    <ListGroup.Item>
                                        <div>
                                            <div class="d-flex align-items-center">
                                                <div class="pic_labels_img">
                                                    <img src={Pic} alt="" />
                                                </div>
                                                <div class="ms-2 w-100">
                                                    <Row class="justify-content-between">
                                                        <Col>
                                                            <div className="lh-1">
                                                                <h5 class="text-black fs-15 fw-500 m-0">Session Booked</h5>
                                                                <label className="fs-12 fw-400">Annette Black</label>
                                                            </div>
                                                        </Col>
                                                        <Col sm="auto">
                                                            <span className="fs-10 fw-400 brand_text_color3">Mon,11:50</span>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </div>
                                        </div>
                                    </ListGroup.Item>
                                    <ListGroup.Item>
                                        <div>
                                            <div class="d-flex align-items-center">
                                                <div class="pic_labels_img">
                                                    <img src={Pic} alt="" />
                                                </div>
                                                <div class="ms-2 w-100">
                                                    <Row class="justify-content-between">
                                                        <Col>
                                                            <div className="lh-1">
                                                                <h5 class="text-black fs-15 fw-500 m-0">Session Booked</h5>
                                                                <label className="fs-12 fw-400">Annette Black</label>
                                                            </div>
                                                        </Col>
                                                        <Col sm="auto">
                                                            <span className="fs-10 fw-400 brand_text_color3">Mon,11:50</span>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </div>
                                        </div>
                                    </ListGroup.Item>
                                    <ListGroup.Item>
                                        <div>
                                            <div class="d-flex align-items-center">
                                                <div class="pic_labels_img">
                                                    <img src={Pic} alt="" />
                                                </div>
                                                <div class="ms-2 w-100">
                                                    <Row class="justify-content-between">
                                                        <Col>
                                                            <div className="lh-1">
                                                                <h5 class="text-black fs-15 fw-500 m-0">Session Booked</h5>
                                                                <label className="fs-12 fw-400">Annette Black</label>
                                                            </div>
                                                        </Col>
                                                        <Col sm="auto">
                                                            <span className="fs-10 fw-400 brand_text_color3">Mon,11:50</span>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </div>
                                        </div>
                                    </ListGroup.Item>
                                </ListGroup>
                            </div>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </section>
        
        </>
    )
}
export default NotificationFrontPage;